import { LeadPaymentMethod } from "../../models/Lead";

export default function PaymentMethodCell({ paymentMethod }: { paymentMethod: LeadPaymentMethod }) {
    var classNames = "rounded-full px-3 py-1 text-xs font-semibold text-nowrap ";
    
    switch (paymentMethod) {
        case LeadPaymentMethod["Bank Transfer"]:
            classNames += "bg-blue-100 text-blue-800";
            break;

        case LeadPaymentMethod["Cheque"]:
            classNames += "bg-green-100 text-green-800";
            break;

        case LeadPaymentMethod["Cash"]:
            classNames += "bg-yellow-100 text-yellow-800";
            break;

        default:
            classNames += "bg-gray-100 text-gray-800";
            break;
    }

    return <span className={classNames}>{LeadPaymentMethod[paymentMethod]}</span>
}

